// extracted by mini-css-extract-plugin
export default {"collapseToggle":"ToggleCollapse_collapseToggle__qhANE","svgContainer":"ToggleCollapse_svgContainer__JCVsN","isCollapse":"ToggleCollapse_isCollapse__3KzCf"};